var render = function render(){var _vm=this,_c=_vm._self._c;return _c('page',{staticClass:"about text-justify",attrs:{"img":"nosotros","alt":"Nosotros","itemscope":"","itemtype":"https://schema.org/AboutPage"}},[_c('responsive-text',{attrs:{"text":"Nosotros","left":{
            916: '5%',
            34: '8%',
            43: '8%',
            169: '12%',
        },"top":{
            916: '50%',
            34: '50%',
            43: '50%',
            169: '50%',
        },"title":""}}),_c('b-row',{staticClass:"mt-5"},[_c('b-col',{staticClass:"d-none d-lg-block",attrs:{"lg":"2"}}),_c('b-col',{staticClass:"d-flex flex-column justify-content-center",attrs:{"cols":"12","sm":"7","md":"8","lg":"7"}},[_c('div',{directives:[{name:"in-viewport",rawName:"v-in-viewport",value:({ margin: '-30px 0px' }),expression:"{ margin: '-30px 0px' }"}],staticClass:"fade-in",staticStyle:{"transition-delay":"0.3s"}},[_c('h2',{staticClass:"h2"},[_vm._v("Historia")]),_c('p',[_vm._v(" ESTSUELCON CÍA. LTDA. es una empresa dedicada al Estudio de Suelos, Laboratorio Construcción y Consultoría Integral; desde sus orígenes considera que la calidad, experiencia, innovación tecnológica y la capacitación de su personal son y serán su carta de presentación, reflejándola en sus servicios. ")]),_c('responsive-img',{directives:[{name:"in-viewport",rawName:"v-in-viewport"}],staticClass:"slide-right d-sm-none",staticStyle:{"transition-delay":"0.3s"},attrs:{"img":"historia","alt":"Historia","ratio":"3:4","sizes":"(min-width: 576px) 1px, calc(100vw - 30px)"}}),_c('p',[_vm._v(" La empresa tiene sus orígenes por los años 1990 como un pequeño Laboratorio de Suelos particular creada por su fundador Ing. Ovidio Castillo docente en esos tiempos en la Universidad Particular de Loja en Cátedra de Mecánica de Suelos y Materiales de Construcción, luego a través de los años y de la capacitación continua de su personal y la inversión en nuevas tecnologías fue ampliando sus servicios al área de la Geotecnia, Geología, Geofísica y Diseño integral de Obras Civiles en General, hasta que en el 2009 se estableció finalmente como Compañía Limitada. ")])],1)]),_c('b-col',{staticClass:"d-none d-sm-flex align-items-center",attrs:{"cols":"0","sm":"5","md":"4","lg":"3"}},[_c('responsive-img',{directives:[{name:"in-viewport",rawName:"v-in-viewport"}],staticClass:"slide-right",staticStyle:{"transition-delay":"0.3s"},attrs:{"img":"historia","alt":"Historia","ratio":"3:4","sizes":"(min-width: 992px) calc(25vw - 30px), (min-width: 768px) calc(33.33vw - 30px), (min-width: 576px) calc(41.67vw - 30px), 1px"}})],1)],1),_c('b-row',{staticClass:"mt-3"},[_c('b-col',{staticClass:"d-none d-lg-block",attrs:{"lg":"2"}}),_c('b-col',{staticClass:"d-flex flex-column justify-content-center",attrs:{"cols":"12","lg":"8"}},[_c('div',{directives:[{name:"in-viewport",rawName:"v-in-viewport",value:({ margin: '-40px 0px' }),expression:"{ margin: '-40px 0px' }"}],staticClass:"fade-in",staticStyle:{"transition-delay":"0.3s"}},[_c('h2',{staticClass:"h2"},[_vm._v("Misión")]),_c('p',[_vm._v(" Ser la empresa líder en consultoría civil, geología y construcción de obras civiles. Satisfaciendo las necesidades de la comunidad ecuatoriana tanto en el ámbito privado como público. Generar valor económico para nuestros clientes, accionistas, proveedores y funcionarios. ")])])]),_c('b-col',{staticClass:"d-none d-lg-block",attrs:{"lg":"2"}})],1),_c('b-row',{staticClass:"mt-3"},[_c('b-col',{staticClass:"d-none d-lg-block",attrs:{"lg":"2"}}),_c('b-col',{staticClass:"d-flex flex-column justify-content-center",attrs:{"cols":"12","lg":"8"}},[_c('div',{directives:[{name:"in-viewport",rawName:"v-in-viewport",value:({ margin: '-40px 0px' }),expression:"{ margin: '-40px 0px' }"}],staticClass:"fade-in",staticStyle:{"transition-delay":"0.3s"}},[_c('h2',{staticClass:"h2"},[_vm._v("Visión")]),_c('p',[_vm._v(" Ser la compañía integradora entre la ciencia y la experiencia, líderes en servicios de calidad, transmisión de conocimientos a las nuevas generaciones y promoción del cuidado al medio ambiente. ")])])]),_c('b-col',{staticClass:"d-none d-lg-block",attrs:{"lg":"2"}})],1),_c('b-row',{staticClass:"mt-3"},[_c('b-col',{staticClass:"d-none d-lg-block",attrs:{"lg":"2"}}),_c('b-col',{staticClass:"d-flex flex-column justify-content-center",attrs:{"cols":"12","lg":"8"}},[_c('div',{directives:[{name:"in-viewport",rawName:"v-in-viewport",value:({ margin: '-40px 0px' }),expression:"{ margin: '-40px 0px' }"}],staticClass:"fade-in",staticStyle:{"transition-delay":"0.3s"}},[_c('h2',{staticClass:"h2"},[_vm._v("Equipo")]),_c('p',[_vm._v(" Nuestro equipo profesional técnico con experiencia y altamente calificados garantizan la calidad en todos nuestros servicios. ")])])]),_c('b-col',{staticClass:"d-none d-lg-block",attrs:{"lg":"2"}})],1),_c('b-row',[_c('b-col',{staticClass:"d-none d-lg-block",attrs:{"lg":"1"}}),_c('b-col',{attrs:{"cols":"12","lg":"10"}},[_c('b-aspect',{directives:[{name:"in-viewport",rawName:"v-in-viewport"}],staticClass:"fade-in mt-5",staticStyle:{"width":"100%","margin":"0 auto -15% !important"},attrs:{"aspect":"16:9"}},[_c('responsive-img',{staticClass:"team-image",attrs:{"img":"equipo","alt":"Equipo","ratio":"16:9","sizes":"(min-width: 992px) calc(83.33vw - 30px), calc(100vw - 30px)","lazy":""}})],1)],1)],1),_c('b-row',{staticClass:"mt-3"},[_c('b-col',{staticClass:"d-none d-lg-block",attrs:{"lg":"2"}}),_c('b-col',{staticClass:"d-flex flex-column justify-content-center",attrs:{"cols":"12","lg":"8"}},[_c('div',{directives:[{name:"in-viewport",rawName:"v-in-viewport",value:({ margin: '-40px 0px' }),expression:"{ margin: '-40px 0px' }"}],staticClass:"fade-in",staticStyle:{"transition-delay":"0.3s"}},[_c('h2',{staticClass:"h2"},[_vm._v("Socios estratégicos")])])]),_c('b-col',{staticClass:"d-none d-lg-block",attrs:{"lg":"2"}})],1),_c('partner',{attrs:{"title":"","activities":[
            {
                name: 'Geotecnia',
                contacts: [
                    {
                        name: 'Ing. Ovidio Castillo',
                        email: 'ovidio.c@estsuelcon.ec',
                        mobile: '+593-980253180',
                    },
                ],
            },
            {
                name: 'Ingeniería Vial',
                contacts: [
                    {
                        name: 'Ing. Diego Castillo',
                        email: 'diego.c@estsuelcon.ec',
                        mobile: '+593-999692335',
                    },
                    {
                        name: 'Ing. Oscar Cango',
                        email: 'olcango@hotmail.com',
                        mobile: '+593-984880314',
                    },
                ],
            },
            {
                name: 'Diseño Geométrico De Vías',
                contacts: [
                    {
                        name: 'Ing. Pablo Paccha',
                        email: 'ppaccha@yahoo.com',
                        mobile: '+593-969581298',
                    },
                ],
            },
            {
                name: 'Infraestructura Bin y Civil 3d',
                contacts: [
                    {
                        name: 'Ing. Marco Guaya',
                    },
                ],
            },
            {
                name: 'Hidrogeología',
                contacts: [
                    {
                        name: 'Ing. Yetzabel Flores',
                        email: 'yegerarda@hotmail.com',
                        mobile: '+593-999817316',
                    },
                    {
                        name: 'Ing. Milena González',
                        email: 'mi_189@hotmail.com',
                        mobile: '+593-967816566',
                    },
                ],
            },
            {
                name: 'Riesgos Geológicos',
                contacts: [
                    {
                        name: 'Ing. Tamara Briceño',
                        email: 'tamycbs@gmail.com',
                        mobile: '+593-995943952',
                    },
                ],
            },
        ]}}),_c('hr',{staticClass:"hr"}),_c('partner',{attrs:{"title":"GRISS-UTPL","img":require('@/assets/logos/griss.png'),"url":"http://ingenieriasismica.utpl.edu.ec","activities":[
            {
                name: 'Estructural',
                contacts: [
                    {
                        name: 'Ing. Edwin Duque',
                        email: 'epduque@utpl.edu.ec',
                        mobile: '+593-992713568',
                    },
                    {
                        name: 'Ing. José Hurtado',
                        email: 'jchurtadoh@gmail.com',
                        mobile: '+593-983004066',
                    },
                ],
            },
        ]}}),_c('hr',{staticClass:"hr"}),_c('partner',{attrs:{"title":"Acuática","activities":[
            {
                name: 'Hidrosanitario y ' + '<span class="text-nowrap">Recursos Hídricos</span>',
                contacts: [
                    {
                        name: 'Ing. Patricio León',
                        email: 'pdleon_86@hotmail.com',
                        mobile: '+593-94457694',
                    },
                    {
                        name: 'Ing. Fernando Jaramillo',
                        email: 'fejaidro@gmail.com',
                        mobile: '+593-988945233',
                    },
                ],
            },
            {
                name: 'Hidrología e Hidráulica',
                contacts: [
                    {
                        name: 'Ing. Rafael González González',
                        email: 're_gonzalez@hotmail.es',
                        mobile: '+593-994945181',
                    },
                    {
                        name: 'Ing. Rafael González Carrión',
                        email: 'rafaelgc17@gmail.com',
                        mobile: '+593-995284687',
                    },
                ],
            },
        ],"right":""}}),_c('hr',{staticClass:"hr"}),_c('partner',{attrs:{"title":"Incoelectric","img":require('@/assets/logos/incoelectric.png'),"url":"https://incoelectric.com","activities":[
            {
                name: 'Eléctrico Y Electrónico',
                contacts: [
                    {
                        name: 'Ing. Ramiro Neptalí Jiménez',
                        email: 'incoelectric@gmail.com',
                        mobile: '+593-985826480',
                    },
                ],
            },
            {
                name: 'Riesgos Sísmicos',
                contacts: [
                    {
                        name: 'Ing. Adriana Ayala',
                        email: 'adrisayala@gmail.com',
                        mobile: '+593-988606110',
                    },
                ],
            },
        ]}}),_c('hr',{staticClass:"hr"}),_c('partner',{attrs:{"title":"Consultoría y Proyectos","img":require('@/assets/logos/consultoria-y-proyectos.png'),"url":"https://www.facebook.com/Consultor%C3%ADa-y-Proyectos-104868954573072/","activities":[
            {
                name:
                    '<span class="text-nowrap">Salud Ocupacional</span>, ' +
                    '<span class="text-nowrap">Seguridad Industrial</span>, ' +
                    '<span class="text-nowrap">Medio Ambiente</span>, ' +
                    '<span class="text-nowrap">Control de Calidad y Proyectos</span>',
                contacts: [
                    {
                        name: 'Ing. Yadira Solórzano',
                        email: 'yadira172@hotmail.com',
                        mobile: '+593-999132722',
                    },
                ],
            },
        ],"right":""}}),_c('hr',{staticClass:"hr"}),_c('partner',{attrs:{"title":"Elemental","img":require('@/assets/logos/elemental.jpg'),"url":"https://www.facebook.com/pages/category/Local-Business/ELEMENTAL-Topograf%C3%ADa-Geodesia-790314331002966","activities":[
            {
                name: 'Topografía y Geodesia',
                contacts: [
                    {
                        name: 'Ing. Felipe Jiménez',
                        email: 'elemental_loja@hotmail.com',
                        mobile: '+593-994797059',
                    },
                    {
                        name: 'Ing. Yandry Lalagui',
                        email: 'yandri92_jar@hotmail.com',
                        mobile: '+593-985091266',
                    },
                ],
            },
        ]}}),_c('hr',{staticClass:"hr"}),_c('partner',{attrs:{"title":"SurHábitat","img":require('@/assets/logos/surhabitat.png'),"url":"https://www.facebook.com/pages/category/Real-Estate-Agent/Estudio-de-Arquitectura-SurH%C3%A1bitat-182959931752831","activities":[
            {
                name: 'Arquitectura',
                contacts: [
                    {
                        name: 'Arq. Ángel Montaño',
                        email: 'arqangelrafael@hotmail.com',
                        mobile: '+593-986827002',
                    },
                    {
                        name: 'Arq. José Morocho',
                        email: 'josemorochoarquitecto@hotmail.com',
                        mobile: '+593-994414678',
                    },
                ],
            },
        ],"right":""}}),_c('hr',{staticClass:"hr"}),_c('partner',{attrs:{"title":"Gema","img":require('@/assets/logos/gema.png'),"url":"https://ec.linkedin.com/in/cesar-morocho-5b8957181","activities":[
            {
                name: 'Minería',
                contacts: [
                    {
                        name: 'Ing. César Morocho',
                        email: 'ts.camp29@gmail.com',
                        mobile: '+593-981687463',
                    },
                ],
            },
        ]}}),_c('hr',{staticClass:"hr"}),_c('partner',{attrs:{"title":"Identidades con Impacto","img":require('@/assets/logos/identidades-con-impacto.png'),"url":"https://identidadesconimpa.wixsite.com/identidadesconimpa-1","activities":[
            {
                name: 'Emprendimiento',
                contacts: [
                    {
                        name: 'Ing. Gaby González',
                        email: 'gaby.2694@hotmail.com',
                        mobile: '+593-995956428',
                    },
                ],
            },
        ],"right":""}}),_c('hr',{staticClass:"hr"}),_c('partner',{attrs:{"title":"Fungeomine","img":require('@/assets/logos/fungeomine.jpg'),"url":"https://www.fungeomine.org","activities":[
            {
                name: 'Investigación Geológica Minera',
                contacts: [
                    {
                        name: 'Ing. Edgar Pillajo',
                        email: 'pillajo2001@yahoo.es',
                        mobile: '+593-994327648',
                    },
                ],
            },
        ]}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }